exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".game-mainstage[data-v-d1487e52]{min-height:60vh}.player-darts[data-v-d1487e52]{grid-area:player-darts;display:grid;grid-template-areas:\"dart1 dart2 dart3\";grid-template-columns:1fr 1fr 1fr}.send_button[data-v-d1487e52],.tttnumber[data-v-d1487e52]{cursor:pointer}.send_button[data-v-d1487e52]{display:block;width:100%;background:#009948;grid-column-start:1;grid-column-end:4;text-align:center;font-size:2vw;color:#fff}", ""]);

// exports
